import React, {useState,} from "react";
import { KYBForm } from "../../interfaces/bank";
import { FileDropzone } from "./FileDropzone";
import { UploadIcon } from "../../assets/svgs/icons-svg";

 // ── KYB Form ──────────────────────────────────────────────────────────────────
export function KYBFormView({ onSave, initialValues }: {
  onSave: (form: KYBForm) => void
  initialValues?: Partial<KYBForm>
}) {
  const [form, setForm] = useState<KYBForm>(() => ({
    businessName: initialValues?.businessName ?? "",
    registrationNumber: initialValues?.registrationNumber ?? "",
    certificateFile: null,
    proofOfAddressFile: null,
    communityAuthorityFile: null,
    authorizedPersonName: initialValues?.authorizedPersonName ?? "",
    uploadIdFile: null,
  }));

  const isValid = !!(form.businessName && form.registrationNumber && form.authorizedPersonName);

  const uploadDocs = [
    { label: "Certificate of Incorporation / Registration", key: "certificateFile" as keyof KYBForm },
    { label: "Proof of Address",                            key: "proofOfAddressFile" as keyof KYBForm },
    { label: "Community Authority / Management Proof",      key: "communityAuthorityFile" as keyof KYBForm },
  ];

  return (
    <div className="space-y-6">
      <h3 className="text-base font-semibold text-gray-900">KYB Verification <span className="font-normal text-gray-500">[1,000,000 Max]</span></h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Business Name */}
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-gray-700">Business Name <span className="text-red-500">*</span></label>
          <input type="text" placeholder="Community wealth" value={form.businessName} onChange={(e) => setForm({ ...form, businessName: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900" />
        </div>

        {/* Registration Number */}
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-gray-700">Registration Number <span className="text-red-500">*</span></label>
          <input type="text" placeholder="XYZ1234567890" value={form.registrationNumber} onChange={(e) => setForm({ ...form, registrationNumber: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900" />
        </div>
      </div>

      {/* Upload Documents */}
      <div className="space-y-3">
        <p className="text-sm font-medium text-gray-700">Upload the following documents to complete your verification process</p>
        {uploadDocs.map(({ label, key }) => (
          <div key={key} className="flex items-center justify-between gap-4">
            <p className="text-sm text-gray-700 flex items-center gap-1">
              <span className="text-gray-400">•</span> {label} <span className="text-red-500">*</span>
            </p>
            <label className="cursor-pointer">
              <input type="file" accept=".pdf,.docx,.txt,image/*" className="hidden" onChange={(e) => { if (e.target.files?.[0]) setForm({ ...form, [key]: e.target.files[0] }); }} />
              <span className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${(form[key] as File | null) ? "bg-green-600 text-white" : "bg-gray-900 text-white hover:bg-gray-700"}`}>
                <UploadIcon />
                {(form[key] as File | null) ? "Uploaded" : "Upload"}
              </span>
            </label>
          </div>
        ))}
      </div>

      {/* Authorized Person */}
      <div className="space-y-4">
        <h4 className="text-sm font-semibold text-gray-900">Authorized Person <span className="font-normal text-gray-500">[Unlimited]</span></h4>
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-gray-700">Name <span className="text-red-500">*</span></label>
          <input type="text" placeholder="Adeyemi Akpan" value={form.authorizedPersonName} onChange={(e) => setForm({ ...form, authorizedPersonName: e.target.value })} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900" />
        </div>
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-gray-700">Upload ID <span className="text-red-500">*</span></label>
          <FileDropzone file={form.uploadIdFile} onChange={(f) => setForm({ ...form, uploadIdFile: f })} />
        </div>
      </div>

      <div className="flex justify-end pt-2">
        <button disabled={!isValid} onClick={() => isValid && onSave(form)} className={`px-6 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${isValid ? 'bg-gray-900 text-white enabled:hover:bg-gray-700 enabled:active:scale-95' : 'bg-gray-200 text-gray-600 disabled:cursor-not-allowed disabled:opacity-100 disabled:transform-none disabled:shadow-none'}`}>Save</button>
      </div>
    </div>
  );
}
